// extracted by mini-css-extract-plugin
export default {"switchAdjust":"FormFieldSwitchPill_switchAdjust__gJgow"};